import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const LanguageContext = createContext();

/**
 * Provider de idioma para o cardápio digital.
 * Suporta 'pt' (padrão) e 'en' (inglês).
 * O idioma selecionado é persistido no localStorage.
 */
export function LanguageProvider({ children }) {
  const [idioma, setIdioma] = useState(() => {
    try {
      return localStorage.getItem('sitri_idioma') || 'pt';
    } catch {
      return 'pt';
    }
  });

  const alterarIdioma = useCallback((novoIdioma) => {
    setIdioma(novoIdioma);
    try {
      localStorage.setItem('sitri_idioma', novoIdioma);
    } catch {
      // silencioso
    }
  }, []);

  /**
   * Retorna o nome do produto no idioma selecionado.
   * Fallback para português se não houver tradução.
   */
  const getNome = useCallback((produto) => {
    if (idioma === 'en' && produto.nome_en) {
      return produto.nome_en;
    }
    return produto.nome;
  }, [idioma]);

  /**
   * Retorna a descrição do produto no idioma selecionado.
   * Fallback para português se não houver tradução.
   */
  const getDescricao = useCallback((produto) => {
    if (idioma === 'en' && produto.descricao_en) {
      return produto.descricao_en;
    }
    return produto.descricao;
  }, [idioma]);

  const value = useMemo(() => ({
    idioma,
    alterarIdioma,
    getNome,
    getDescricao,
  }), [idioma, alterarIdioma, getNome, getDescricao]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage deve ser usado dentro de um LanguageProvider');
  }
  return context;
}

export default LanguageContext;
